var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-layout-component2", {
    attrs: {
      "show-back": "false",
      "show-home": "false",
      "show-admin": "false",
      "show-log": "false",
      "show-user": "false",
      "show-logout": "false",
      "show-notice": false,
      "no-image-nav": true,
      "simple-layout": true
    },
    scopedSlots: _vm._u([
      {
        key: "nav-message",
        fn: function() {
          return [_c("p", [_vm._v("ログイン")])]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            !_vm.showVerification
              ? [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.doLogin($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label",
                              class: {
                                error: _vm.errMailAddress || _vm.errAuth
                              }
                            },
                            [_vm._v("メールアドレス")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "control" }, [
                            _c("input", {
                              directives: [
                                { name: "focus", rawName: "v-focus" },
                                {
                                  name: "model",
                                  rawName: "v-model:value",
                                  value: _vm.username,
                                  expression: "username",
                                  arg: "value"
                                }
                              ],
                              ref: "username",
                              staticClass: "input",
                              class: {
                                "error-ctrl": _vm.errMailAddress || _vm.errAuth
                              },
                              attrs: {
                                type: "text",
                                placeholder: "メールアドレスを入力してください",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.username },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.username = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.mailAddressErrors, function(err) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "control",
                                  class: { error: _vm.errMailAddress }
                                },
                                [_c("label", [_vm._v(_vm._s(err))])]
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label",
                              class: { error: _vm.errPassword || _vm.errAuth }
                            },
                            [_vm._v("パスワード")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "control" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model:value",
                                  value: _vm.password,
                                  expression: "password",
                                  arg: "value"
                                }
                              ],
                              ref: "password",
                              staticClass: "input",
                              class: {
                                "error-ctrl": _vm.errPassword || _vm.errAuth
                              },
                              attrs: {
                                type: "password",
                                placeholder: "パスワードを入力してください",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.passwordErrors, function(err) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "control error",
                                  class: { error: _vm.errPassword }
                                },
                                [_c("label", [_vm._v(_vm._s(err))])]
                              )
                            ]
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.authErrors, function(err) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "control error",
                                  class: { error: _vm.errAuth }
                                },
                                [_c("label", [_vm._v(_vm._s(err))])]
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field pt20" }, [
                        _c("div", { staticClass: "control tc" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-login",
                              attrs: { disabled: _vm.isProcessing }
                            },
                            [_vm._v("ログイン")]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "tc pt10" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.showModal = true
                          }
                        }
                      },
                      [_c("strong", [_vm._v("パスワードをお忘れですか？")])]
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showVerification
              ? [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.doVerification($event)
                        }
                      }
                    },
                    [
                      _c("p", { staticClass: "sendmail" }, [
                        _vm._v(
                          "6桁の確認コードをメールアドレスに送信しました。"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label",
                              class: { error: _vm.errVerification }
                            },
                            [_vm._v("確認コード")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "control" }, [
                            _c("input", {
                              directives: [
                                { name: "focus", rawName: "v-focus" },
                                {
                                  name: "model",
                                  rawName: "v-model:value",
                                  value: _vm.verificationCode,
                                  expression: "verificationCode",
                                  arg: "value"
                                }
                              ],
                              ref: "code",
                              staticClass: "input",
                              class: { "error-ctrl": _vm.errVerification },
                              attrs: {
                                type: "verificationCode",
                                placeholder: "確認コードを入力してください",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.verificationCode },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.verificationCode = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.verificationErrors, function(err) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "control",
                                  class: { error: _vm.errVerification }
                                },
                                [_c("label", [_vm._v(_vm._s(err))])]
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field pt20" }, [
                        _c("div", { staticClass: "control tc" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-login",
                              attrs: { disabled: _vm.isProcessing }
                            },
                            [_vm._v("確認")]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "tc pt10" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.resendVarification($event)
                          }
                        }
                      },
                      [_c("strong", [_vm._v("確認コードを再度送信する")])]
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showModal
              ? _c(
                  "modal-component",
                  {
                    attrs: { "is-quest": "false" },
                    on: {
                      modalOk: function($event) {
                        _vm.showModal = false
                      }
                    }
                  },
                  [
                    _c("h4", { attrs: { slot: "header" }, slot: "header" }, [
                      _vm._v("パスワードの確認")
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "body" },
                        slot: "body"
                      },
                      [_vm._v("管理者にお問い合わせください。")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showResendVerificationModal
              ? _c(
                  "modal-component",
                  {
                    attrs: { "is-quest": "false" },
                    on: {
                      modalOk: function($event) {
                        _vm.showResendVerificationModal = false
                      }
                    }
                  },
                  [
                    _c("h4", { attrs: { slot: "header" }, slot: "header" }, [
                      _vm._v("確認コードの再送信")
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "body" },
                        slot: "body"
                      },
                      [_vm._v("確認コードをメールアドレスに送信しました")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showSendVerificationErrorModal
              ? _c(
                  "modal-component",
                  {
                    attrs: { "is-quest": "false" },
                    on: {
                      modalOk: function($event) {
                        _vm.showSendVerificationErrorModal = false
                      }
                    }
                  },
                  [
                    _c("h4", { attrs: { slot: "header" }, slot: "header" }, [
                      _vm._v("エラー")
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { slot: "body" },
                        slot: "body"
                      },
                      [_vm._v("しばらく経ってから再度お試しください")]
                    )
                  ]
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }